var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"v-chip",class:( _obj = {}, _obj[_vm.color] = _vm.color, _obj[("v-chip__size--" + _vm.size)] = _vm.size, _obj.strong = _vm.strong, _obj.rounded = _vm.rounded, _obj.disabled = _vm.disabled, _obj )},[(_vm.icon)?_c('div',{staticClass:"v-chip__icon"},[_c('v-icon',{attrs:{"icon":_vm.icon}})],1):_vm._e(),_c('div',{staticClass:"v-chip__content"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }